import { Menu as MenuAntd } from 'antd'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { useLocation } from 'react-router'

import { useMenuNavigation } from '@/Core/Hooks/useMenuNavigation'
import { userManager } from '@/Core/Managers'
import { resourceManager } from '@/Core/Managers/Resource'
import { Menu as menuInputs } from '@/Ship/Menu'
import { resolveMenuSelectedKeys } from '@/Ship/Helpers/menuSelection'
import { FilterMenuByAccessTask } from '@/Ship/Tasks/FilterMenuByAccessTask'

import styles from './Menu.module.css'

export const Menu = observer(() => {
    const memoizedMenuInputs = useMemo(() => menuInputs, [])
    const { pathname } = useLocation()

    const { menuItems, handleMenuClick, selectedKeys, openKeys, handleOpenChange } =
        useMenuNavigation(memoizedMenuInputs)

    // Filter by resource access. Reading userManager.user keeps this reactive:
    // permissions arrive asynchronously after login, so the menu re-filters
    // once they are available. `permissions` is an intentional dep — the filter
    // reads it internally, so it must recompute when it changes.
    const permissions = userManager.user?.['permissions']
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const visibleItems = useMemo(() => FilterMenuByAccessTask(menuItems), [menuItems, permissions])

    // Довідники не мають власних пунктів меню — на їхніх сторінках підсвічуємо «Довідники»
    const effectiveSelectedKeys = useMemo(
        () => resolveMenuSelectedKeys(selectedKeys, pathname, resourceManager.getAll()),
        [selectedKeys, pathname]
    )

    return (
        <div className={styles['menuContainer']}>
            <MenuAntd
                mode="inline"
                selectedKeys={effectiveSelectedKeys}
                openKeys={openKeys}
                onOpenChange={handleOpenChange}
                items={visibleItems}
                onClick={handleMenuClick}
            />
        </div>
    )
})
